import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Tabs, { useControlledTabs } from '../../../components/Tabs';
import Title from '../../../components/Title';
import RemoteConfigurationShow from '../../../components/sdk/RemoteConfigurationShow';
import { useGetGlobalRemoteConfigurationQuery } from '../../../api/remoteConfigurationApiSlice';
import RemoteConfigurationHistory from '../../../components/sdk/RemoteConfigurationHistory';
import { Button } from 'react-bootstrap';
import Icon from '../../../components/Icon';

const RemoteConfiguration = (props) => {
  const { t } = useTranslation()
  const { data, isLoading, isSuccess } = useGetGlobalRemoteConfigurationQuery()
  const [tabProps,] = useControlledTabs('defaultConfiguration', props)
  const [showModal, setShowModal] = useState(false)

  const tab2key = (tab)=>{
    if (tab == 'defaultConfiguration') {
      return "default"
    } else if (tab == 'iosConfiguration') {
      return "ios"
    } else if (tab == 'androidConfiguration') {
      return "android"
    } else {
      return null
    }
  }

  useEffect(() => {
    console.log(tab2key(tabProps.active));
  }, [tabProps.active])

  if ( !isSuccess ) { return (<></>) }

  return (
    <>
      <Title main={'SDK'} sub={t("remoteConfiguration.sub")}>
        <Button onClick={()=>setShowModal(true)}>
          <Icon icon='timeline' text={t("history")} />
        </Button>
      </Title>
      <Tabs {...tabProps}>
        <RemoteConfigurationShow as={'defaultConfiguration'} configuration={data["default"]} icon={"branch"}/>
        <RemoteConfigurationShow as={'iosConfiguration'} configuration={data["ios"]} icon={"branch"}/>
        <RemoteConfigurationShow as={'androidConfiguration'} configuration={data["android"]} icon={"branch"}/>
      </Tabs>
      <RemoteConfigurationHistory show={showModal} onClose={()=>(setShowModal(false))} configurable={data[tab2key(tabProps.active)]}/>
    </>
  );
}

export default RemoteConfiguration;